import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Error } from '../../models/error.model';
import { CompanyBookingJournals } from '../../models/company.booking.journals.model';
import { Company } from '../../models/company.model';
import { BookingJournal } from '../../models/booking.journal.model';
import { Message } from '../../models/message.model';
import { authToken } from '../../scripts/authentication.script';

export class BookingJournalDA {
  static apiResponse: ApiResponse

  public static async getBookingJournals(
    id_company: string,
    booking_journal_name: string,
    sort_field: string,
    sort_mode: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let companyBookingJournals: CompanyBookingJournals | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/booking.journals.data.json').then(response => { companyBookingJournals = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (companyBookingJournals!.id_company === id_company) {
        companyBookingJournals!.filter = { name: booking_journal_name, sort_field: sort_field, sort_mode: sort_mode }

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: companyBookingJournals
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/journals?name=${booking_journal_name}&sort_field=${sort_field}&sort_mode=${sort_mode}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async getBookingJournal(
    id_company: string,
    id_booking_journal: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let bookingJournal: BookingJournal | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/booking.journal.data.json').then(response => { bookingJournal = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (bookingJournal!.id === id_booking_journal) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: bookingJournal
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/journals/${id_booking_journal}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async postBookingJournal(
    id_company: string,
    name: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let company: Company | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/company.data.json').then(response => { company = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (company!.id === id_company) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/journals`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        name: name
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async putBookingJournal(
    id_company: string,
    id_booking_journal: string,
    name: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let bookingJournals: BookingJournal[] | null = null
      let bookingJournal: BookingJournal | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/booking.journals.data.json').then(response => { bookingJournals = response.data.booking_journals }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (bookingJournals!.some(item => item.id === id_booking_journal)) {
        bookingJournal = bookingJournals!.find(item => item.id === id_booking_journal)!
        bookingJournal.name = name

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: bookingJournal
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/journals/${id_booking_journal}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        name: name
      }

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }
}
